import { BidProfileStatus, UkgDateFormat } from '../../Enums';
import { getBidProcessTypeLabel, getScheduleSourceLabel } from '../../Enums/Helpers/LabellingHelper';
import DateFormatService from '../../services/DateFormatService';

export const formatData = (/** @type {BidProfile.IBriefBaseProfile[]} */ data) => data.map((d) => (
    { ...d, children: d.rebidParents?.map((x) => ({ ...x })) }
));
/**
 * @param {BidProfile.IBriefBaseProfile} bid
 * @returns {boolean}
 */
export const hasRebidParents = (/** @type {BidProfile.IBriefBaseProfile} */ bid) => !!bid.rebidParents && !!bid.rebidParents.length;

export const hasCreationAccess = (/** @type {BidProfile.IBriefBaseProfile} */rowData) =>
    rowData.status === BidProfileStatus.Draft || rowData.isCreationAllowed;

/**
 * @param {BidProfile.IBriefBaseProfile} rowData
 * @param {string} anytimeLabel
 */
export const getRequestPeriodLabel = (rowData, anytimeLabel) => (
    `${DateFormatService.formatDateOrEmpty(rowData.requestPeriodStartDate, UkgDateFormat.LongDate)}`
    + ` - ${(rowData.isForeverRequestPeriod ? anytimeLabel : DateFormatService.formatDateOrEmpty(rowData.requestPeriodEndDate, UkgDateFormat.LongDate))}`
);

/**
 * @param {string|Date|null} date 
 */
export const getSubmissionDateLabel = (date) => (
    DateFormatService.formatDateOrEmpty(
        date,
        UkgDateFormat.LongDateTime,
    )
);

/** @type {(bid: BidProfile.IBriefBaseProfile, anytimeLabel: string) => string} */
export const searchableBid = (bid, anytimeLabel) => `${bid.name}
        |${bid.description}
        |${bid.hyperfindLabel}
        |${getRequestPeriodLabel(bid, anytimeLabel)}
        |${getBidProcessTypeLabel(bid.bidProcessType)}
        |${getScheduleSourceLabel(bid.scheduleSource)}
        |${getSubmissionDateLabel(bid.submissionPeriodStartDate)}
        |${getSubmissionDateLabel(bid.submissionPeriodEndDate)}
        `.toLocaleLowerCase();

/**
 * @param {BidProfile.IBriefBaseProfile} bid
 * @param {BidProfileStatus[]} statusFilterSelected
 * @returns {boolean}
 */
export const rebidParentsContainsStatus = (bid, statusFilterSelected) => (hasRebidParents(bid)
    // @ts-ignore
    && bid.rebidParents.some((x) => statusFilterSelected.includes(x.status)));

/**
 * @param {BidProfileStatus[]} allStatus
 * @param {BidProfile.IBriefBaseProfile[]} allBids
*/
export const addRebidParentsStatusToFilter = (allStatus, allBids) => {
    // @ts-ignore
    if (allBids.some((x) => rebidParentsContainsStatus(x, [BidProfileStatus.Published]))) {
        if (!allStatus.includes(BidProfileStatus.Published)) {
            allStatus.push(BidProfileStatus.Published);
        }
    }
    // @ts-ignore
    if (allBids.some((x) => rebidParentsContainsStatus(x, [BidProfileStatus.Canceled]))) {
        if (!allStatus.includes(BidProfileStatus.Canceled)) {
            allStatus.push(BidProfileStatus.Canceled);
        }
    }
};
